import { render, staticRenderFns } from "./DisneyPlusPromo.vue?vue&type=template&id=f81f32ca&scoped=true&"
import script from "./DisneyPlusPromo.vue?vue&type=script&lang=ts&"
export * from "./DisneyPlusPromo.vue?vue&type=script&lang=ts&"
import style0 from "./DisneyPlusPromo.vue?vue&type=style&index=0&id=f81f32ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81f32ca",
  null
  
)

export default component.exports